import { Check, Minus } from "lucide-react";
import { PACKAGES } from "@/lib/catalog";
import { inr } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

const Y = true;
const N = false;
const ROWS = [
  ["Website Development (Mobile Friendly Design)", Y, Y, "Custom"],
  ["Contact Form Integration", Y, Y, Y],
  ["WhatsApp Chat Button Integration", Y, Y, Y],
  ["Google Maps Integration", Y, Y, Y],
  ["Google Business Profile Setup", Y, Y, Y],
  ["Digital Business Card", Y, Y, Y],
  ["Website Maintenance", "1 Month", "3 Months", "6 Months"],
  ["Domain Registration", Y, Y, Y],
  ["Hosting Setup", Y, Y, Y],
  ["Social Media Links Integration", Y, Y, Y],
  ["Payment Gateway Integration", N, Y, Y],
  ["Google Review Automation (Review Link Setup & WhatsApp)", N, Y, Y],
  ["Basic SEO Setup", N, Y, Y],
  ["AI-Powered Basic Chatbot", N, N, Y],
  ["CRM Integration", N, N, Y],
  ["WhatsApp Automation", N, N, Y],
  ["Online Appointment & Booking System Setup", N, N, Y],
  ["Google Search Console & Analytics Setup", N, Y, Y],
];

const Cell = ({ v }) => {
  if (v === true) return <Check className="mx-auto h-5 w-5 text-[#00F0FF]" aria-label="Included" />;
  if (v === false) return <Minus className="mx-auto h-4 w-4 text-slate-500" aria-label="Not included" />;
  return <span className="font-mono text-[11px] font-semibold text-white sm:text-sm">{v}</span>;
};

export const PackageCompare = () => {
  const pkgs = PACKAGES.slice(0, 3);
  return (
    <Reveal className="mt-16">
      <h3 className="font-display text-2xl font-bold text-white sm:text-3xl">Compare packages</h3>
      <div className="mt-6 overflow-hidden rounded-3xl border border-white/10 bg-[#0E1526]" data-testid="package-compare-table">
        <table className="w-full table-fixed border-collapse text-xs sm:table-auto sm:text-sm">
          <colgroup><col className="w-[38%] sm:w-auto" /><col /><col /><col /></colgroup>
          <thead>
            <tr className="border-b border-white/10">
              <th className="p-3 text-left font-mono text-[11px] font-normal uppercase tracking-[0.15em] text-slate-400 sm:p-4 sm:text-xs">Feature</th>
              {pkgs.map((p, i) => (
                <th key={p.id} className={`px-1 py-3 text-center align-bottom sm:p-4 ${i === 0 ? "bg-[#00F0FF]/[0.06]" : ""}`} data-testid={`compare-head-${p.id}`}>
                  <p className="font-display text-xs font-bold text-white sm:text-lg">{p.name.replace(" Package", "")}</p>
                  <p className="mt-1 font-mono text-[11px] text-[#00F0FF] sm:text-sm">{inr(p.price)}</p>
                  {p.soon && <p className="mt-1 font-mono text-[9px] uppercase tracking-wider text-amber-200 sm:text-[10px]">Coming soon</p>}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map(([label, ...vals], r) => (
              <tr key={label} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02]" data-testid={`compare-row-${r + 1}`}>
                <td className="p-3 text-slate-200 sm:p-4">{label}</td>
                {vals.map((v, i) => <td key={i} className={`px-1 py-3 text-center sm:p-4 ${i === 0 ? "bg-[#00F0FF]/[0.06]" : ""}`}><Cell v={v} /></td>)}
              </tr>
            ))}
            <tr className="border-t border-white/10">
              <td className="p-3 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-400 sm:p-4 sm:text-xs">Total features</td>
              {pkgs.map((p, i) => <td key={p.id} className={`px-1 py-3 text-center font-mono text-white sm:p-4 ${i === 0 ? "bg-[#00F0FF]/[0.06]" : ""}`} data-testid={`compare-total-${p.id}`}>{p.features.length}</td>)}
            </tr>
          </tbody>
        </table>
      </div>
    </Reveal>
  );
};
